import React, { useState } from 'react';
import styling from './searchable.module.css';
import { filterObjects } from '../../helpers/searchFunctionality';

export default function SearchableDropdown ({ objects, onSelect }) {

    const [searchText, setSearchText] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const filteredObjects = filterObjects(searchText, objects);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    }

    const handleInputChange = (e) => {
        setSearchText(e.target.value);
    }

    const handleSelect = (selectedObject) => {
        onSelect(selectedObject);
        setSearchText(selectedObject.attributes.name);
        setIsOpen(false);
    }

    return(
        <div className={styling.container}>
            <input 
                type="text"
                placeholder="Søk..."
                value={searchText}
                onChange={handleInputChange}
                onClick={toggleDropdown}
                className={styling.input}
            />
            <div className={styling.container2}>
                <ul className={`${styling.list} ${isOpen? `${styling.open}` : `${styling.closed}`}`}>
                    {filteredObjects.map(object => (
                        <li key={object.id} className={styling.li} onClick={() => handleSelect(object)}>
                            <div>{object.attributes.name}</div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export function SearchableDropdownOrderedProducts ({ objects, onSelect }) {

    const [searchText, setSearchText] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const filteredObjects = filterObjects(searchText, objects);

    const sortedObjects = filteredObjects.sort((a,b) => {
        const nameA = a.attributes?.supplier?.data?.attributes?.name?.toLowerCase();
        const nameB = b.attributes?.supplier?.data?.attributes?.name?.toLowerCase();
        if(nameA < nameB) return -1;
        if(nameA > nameB) return 1;
        return 0;
    })

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    }

    const handleInputChange = (e) => {
        setSearchText(e.target.value);
    }

    const handleSelect = (selectedObject) => {
        onSelect(selectedObject);
        setSearchText(selectedObject.attributes.name);
        setIsOpen(false);
    }

    return(
        <div className={styling.container}>
            <input 
                type="text"
                placeholder="Søk..."
                value={searchText}
                onChange={handleInputChange}
                onClick={toggleDropdown}
                className={styling.input}
            />
            <div className={styling.container2}>
                <ul className={`${styling.list} ${isOpen? `${styling.open}` : `${styling.closed}`}`}>
                    {sortedObjects.map(object => (
                        <li key={object.id} className={styling.li} onClick={() => handleSelect(object)}>
                            <div>{object.attributes?.supplier?.data?.attributes?.name} {object.attributes.name}</div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}